import "./Newsletter.css"
const Newsletter = () => {
    return (
        <section className="newsletter">
            <div className="container ">
                <div className="flex">
                <div className="newsletter__text">
                    <h2>Get Early Access Today</h2>
                    <h4>It only takes a minute to sign up and our free starter tier is extremely generous. If you have any questions, our support team would be happy to help you.</h4>
                </div>
                    <div className="form">
                    <form action="" className="ns">
                        <input id="text" type="text" placeholder="Enter Your Mail....." />
                        
                            <button className="hero__button">Get Started For Free</button>
                         
                        </form>
                    </div>
                    </div>
            </div>
        </section>
    )
}

export default Newsletter
